import PropTypes from 'prop-types'
import React, { useCallback, useContext } from 'react'
import { UsuarioContext } from '../context/usuarioContext'
import { useDropzoneUpload } from '../hooks/useDropzoneUpload'
import useError from '../hooks/useError'
import ImagenDni from '../imagen/ImagenDni'
import * as imagenesPerfilService from '../servicios/imagenesPerfilService'

const Upload = ({ idUsuario, accept, idTipo, onCheck, name, errores }) => {
  const { ShowError } = useError(errores, name)
  const { setImagenModif } = useContext(UsuarioContext)

  const buildFormData = useCallback(
    (archivo) => {
      const imagen = new FormData()
      imagen.append('nombre', archivo.name)
      imagen.append('idUsuario', idUsuario)
      imagen.append('archivo', archivo)
      imagen.append('idTipo', idTipo)
      return imagen
    },
    [idUsuario, idTipo]
  )

  const { getRootProps, getInputProps } = useDropzoneUpload({
    accept,
    buildFormData,
    uploadFn: imagenesPerfilService.subirArchivo,
    onSuccess: (archivo) => {
      setImagenModif(archivo.lastModified)
      onCheck(idTipo)
    }
  })
  const textosDNI = {
    1: 'frente',
    2: 'dorso'
  }

  return (
    <>
      <div className="borde-hormiga text-center" {...getRootProps()}>
        <input {...getInputProps()} />
        <div className="row-img-subida contenedor-cont-img-subida-perfil">
          <div className="row">
            <div className="col-6 col-xl-3">
              <div className="row">
                <div className="col-12">
                  <div className="cont-img-subida-perfil">
                    <ImagenDni idUsuario={idUsuario} clase="subida-img" idTipo={idTipo}></ImagenDni>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p>
          Hacé click para cargar la imagen del {textosDNI[idTipo]} de tu DNI. Soltala acá ó
          arrastrala desde tu computadora.
        </p>
      </div>
      {<ShowError />}
    </>
  )
}

Upload.propTypes = {
  idUsuario: PropTypes.number.isRequired,
  accept: PropTypes.object.isRequired,
  idTipo: PropTypes.number.isRequired,
  onCheck: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  errores: PropTypes.object
}

export default React.memo(Upload)
